var _polygon, _text;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6,1 18,1 23,6 23,18 18,23 6,23 1,18 1,6",
    fill: "#DC3545"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 12.4,
    fontFamily: "Arial, sans-serif",
    fontSize: 6.6,
    fontWeight: 700,
    fill: "white",
    textAnchor: "middle",
    dominantBaseline: "middle",
    letterSpacing: 0.25
  }, "EMCY")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.ddb7933149d3f8b11ce80613373cbaff.svg";
export { ForwardRef as ReactComponent };